import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";

import { ILogEntries, ILogEntry } from "../../Lib/Log/types";
import { formatDataLogLine, formatMainLogLine, getEntriesAsString } from "./utils";
import CopyToClipboardButton from "../../Lib/UI/Components/CopyToClipboardButton";
import { useInstantNotifier } from "../../Lib/Notifier/useInstantNotifier";


interface LogViewProps {
    log: ILogEntries;
};

const LogView = (props: LogViewProps) => {

    const notifier = useInstantNotifier();

    const [entries, setEntries] = useState<ILogEntry[]>([]);

    const handleEntriesChanged = useCallback(() => {
        setEntries(props.log.entries.sort((a , b) => b.at.getTime() - a.at.getTime()));
    }, [props.log]);

    useEffect(() => {

        props.log.on('entriesChanged', handleEntriesChanged);
        handleEntriesChanged();

        return () => {
            props.log.off('entriesChanged', handleEntriesChanged);
        };

    }, [props.log, handleEntriesChanged]);

    return (
        <Box sx={{ whiteSpace: 'nowrap', overflow: 'auto' }}>
            <CopyToClipboardButton notifier={notifier} getData={() => getEntriesAsString(entries)} title="Copy log contents to your clipboard" />
        {entries.map((entry, idx) => 
            <Box sx={{ marginBottom: 2 }} key={idx}>
                <pre>{formatMainLogLine(entry)}</pre>
                <pre>{!!entry.data && formatDataLogLine(entry)}</pre>
            </Box>
        )}
        </Box>
    );
};

export default LogView;